import React, {useContext} from 'react';
import {
  Alert, AlertDescription, AlertIcon, AlertTitle, Box,
  Button,
  Center, CloseButton,
  Flex,
  FormControl,
  Heading,
  Input,
  Text, useDisclosure, useToast,
  VStack,
} from '@reverb-ui/react';
import {ArrowCornerDownLeft, ChevronRight} from '@reverb-ui/icons-react';
import { FormLabel } from '@chakra-ui/form-control';
import { useForm } from 'react-hook-form';
import api from '../../services/api';
import {AuthContext} from "../../contexts/auth";
import {useHistory} from "react-router-dom";

const ResetPassword = () => {
  const { register, handleSubmit } = useForm();
  const {logout} = useContext(AuthContext)
  const history = useHistory()

  const backToLogin = async () => {
    logout()
    history.push("/login")
  }

  const {
    isOpen: isErrorAlertOpen,
    onClose: closeErrorAlert,
    onOpen: openErrorAlert,
  } = useDisclosure()

  const {
    isOpen: isSuccessAlertOpen,
    onClose: closeSuccessAlert,
    onOpen: openSuccessAlert,
  } = useDisclosure()

  const toast = useToast()

  const submitResetPassword = async (data: { email: string }) => {
    try {
      const response = await api.post('/Authentication/password/forgot', data);
      if (response.status === 200) {
        openSuccessAlert()
      }
    } catch (error) {
      openErrorAlert()
    }
  };

  return (
    <Center
      bg="white"
      w="full"
      flexDirection="column"
      borderRadius="2xl"
      padding={[null, null, 8, 12]}
    >
      <VStack spacing={16}>
        <VStack alignItems="start">
          <Heading
            as="h1"
            fontFamily="manrope"
            fontSize={{ "base": "2xl", "tablet-md": "5xl" }}
            fontWeight="extrabold"
          >
            Reset password{' '}
          </Heading>

          {isErrorAlertOpen && (
              <Box py={3} w="full">
                <Alert status="error" alignItems="start" w="full" borderRadius={6}>
                  <AlertIcon h="15px" mt={2} />
                  <Box flex={1}>
                    <AlertTitle>Houston, we have a problem!</AlertTitle>
                    <AlertDescription fontSize="sm">
                      We couldn't find your e-mail.
                    </AlertDescription>
                  </Box>
                  <CloseButton onClick={closeErrorAlert} size="sm" />
                </Alert>
              </Box>
          )}

          {isSuccessAlertOpen && (
              <Box py={3}>
                <Alert status="success" alignItems="start" borderRadius={6}>
                  <AlertIcon h="15px" mt={2} />
                  <Box flex={1}>
                    <AlertTitle>E-mail sent!</AlertTitle>
                    <AlertDescription fontSize="sm">
                      Check your inbox for further instructions
                    </AlertDescription>
                  </Box>
                  <CloseButton onClick={closeSuccessAlert} size="sm" />
                </Alert>
              </Box>
          )}
          <Text fontSize="md" maxWidth="sm">
            We’ll send an e-mail with instructions to reset your password and
            get you back on the game.
          </Text>
        </VStack>

        <Flex width="full" sx={{ '.formResetPassword': { width: '100%' } }}>
          <form
            onSubmit={handleSubmit(submitResetPassword)}
            className="formResetPassword"
          >
            <VStack spacing={8} width="full">
              <FormControl>
                <VStack spacing={12}>
                  <VStack width="full" alignItems="start">
                    <FormLabel
                      fontSize="md"
                      htmlFor="email"
                      fontWeight="medium"
                    >
                      E-mail
                    </FormLabel>
                    <Input
                      placeholder="Enter your e-mail"
                      id="email"
                      aria-label="email"
                      type="email"
                      size="md"
                      variant="outline"
                      {...register('email', {
                        required: true
                      })}
                    />
                  </VStack>
                  <Flex width="full" justifyContent="center">
                    <Button
                      size="lg"
                      bg="blue.500"
                      color="white"
                      colorScheme="blue"
                      rightIcon={<ChevronRight color="white" />}
                      type="submit"
                    >
                      Reset password
                    </Button>
                  </Flex>
                </VStack>
              </FormControl>
            </VStack>
          </form>
        </Flex>
        <VStack>
          <Button
            onClick={backToLogin}
            leftIcon={<ArrowCornerDownLeft color="blue.500" />}
            variant="ghost"
            color="blue.500"
          >
            Back to login
          </Button>
        </VStack>
      </VStack>
   </Center>
  );
};

export default ResetPassword;
